import './App.css';
import AppHeader from './components/AppHeader';
import Footer from './components/footer/Footer';
import IconLink from './components/icon-link/IconLink';
import playStorIcon from './assets/icons/GooglePlay.svg'
import appStoreIcon from './assets/icons/AppStore.svg'
import background from './assets/images/background.jpeg'
import placeholderBackground from './assets/images/background-placeholder.jpeg'
import AppImageBackground from './components/app-image-background/AppImageBackground';
import frame from './assets/images/frame.png'
import screen_1 from './assets/images/screenshot_1.png'
import screen_2 from './assets/images/screenshot_2.png'
import screen_3 from './assets/images/screenshot_3.png'
import screen_4 from './assets/images/screenshot_4.png'
import screen_5 from './assets/images/screenshot_5.png'
import screen_6 from './assets/images/screenshot_6.png'
import screen_7 from './assets/images/screenshot_7.png'
import screen_8 from './assets/images/screenshot_8.png'
import screen_9 from './assets/images/screenshot_9.png'
import screen_10 from './assets/images/screenshot_10.png'
import screen_11 from './assets/images/screenshot_11.png'
import DeviceFrameCanvas from './components/device-frame/DeviceFrameCanvas';
import { useEffect, useState } from 'react';
import { NotifyButton } from './components/NotifyButton';

const PLAYSTORE_URL = "https://play.google.com/store/apps/details?id=app.puzzle.padaku&hl=en_US&pli=1"
const APPSTORE_URL = "https://apps.apple.com/us/app/padaku-kannda-word-puzzle/id6497877266"

const screenShots = [
  screen_1,
  screen_2,
  screen_3,
  screen_4,
  screen_5,
  screen_6,
  screen_7,
  screen_8,
  screen_9,
  screen_10,
  screen_11,
]

function App() {

  const [screenShotIndex, setScreenShotIndex] = useState(0)

  useEffect(() => {
    const intervalId = setInterval(() => {
      setScreenShotIndex((current: number) => (current + 1) % screenShots.length)
    }, 1000)
    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <div className="App">
      <NotifyButton/>
      <AppImageBackground placeholderBackground={placeholderBackground} background={background}>
        <AppHeader/>
        <main>
          <section className="info-container">
            <div className='about'>
              <p>This app brings you Kannada adaptations of the world’s most popular word puzzles !</p>
            </div>
            <div className='app-links-container'>
              <IconLink imgSrc={playStorIcon} link={{ url: PLAYSTORE_URL }} />
              <IconLink imgSrc={appStoreIcon} link={{ url: APPSTORE_URL }} />
            </div>
          </section>
          <DeviceFrameCanvas
            frameSrc={frame}
            screenshotSrc={screenShots[screenShotIndex]}
            screenX={99/2}
            screenY={199/2}
            screenHeight={2282/2}
            screenWidth={1082/2}
          ></DeviceFrameCanvas>
        </main>
        <Footer />
      </AppImageBackground>
    </div>
  );
}

export default App;
